import { getters } from './getters';
import * as actions from './actions';
import { mutations } from './mutations';
import { state } from './models';

export const menuEditorModule = {
  state,
  getters,
  actions,
  mutations
};
